import LocationSetting from './LocationSetting'
import ScheduleSetting from './ScheduleSetting'
import WidgetSetting from './WidgetSetting'
import WifiSetting from './WifiSetting'
import CustomMessageSetting from './CustomMessageSetting'
import ProductSuggestionSetting from './ProductSuggestionSetting'
import SocialMediaSettings from './SocialMediaSettings'

export default function GeneralSettings() {
  return (
    <>
      <SocialMediaSettings />

      <div className="settings-group">
        <WifiSetting />
        <LocationSetting />
        <ScheduleSetting />
      </div>

      <WidgetSetting />
      <CustomMessageSetting />
      <ProductSuggestionSetting />
    </>
  )
}
